import { unregisterApplication } from 'single-spa';
var HelpersService = /** @class */ (function () {
    function HelpersService() {
    }
    /**
     * Función para comparar dos fechas
     *
     * *Function to compare two dates*
     *
     * @type {function}
     * @param {string} d1
     * @param {string} d2
     * @returns {number}
     */
    HelpersService.prototype.compareDates = function (d1, d2) {
        var date1 = d1.split('/');
        var date2 = d2.split('/');
        var date1UTC = Date.UTC(+date1[2], +date1[1] - 1, +date1[0]);
        var date2UTC = Date.UTC(+date2[2], +date2[1] - 1, +date2[0]);
        return Math.floor((date1UTC - date2UTC) / (1000 * 60 * 60 * 24));
    };
    /**
     * Convierte un string de versión a un número entero
     *
     * *Converts a version string to int number*
     * @param {string} version
     * @returns {number}
     */
    HelpersService.prototype.versionToNumber = function (version) {
        return parseInt(version.replace(/\./g, ''), 10);
    };
    /**
     * Pone array de datos enviados dentro de un string
     *
     * *Puts a data array sent inside an string*
     * @param {string} text
     * @param {string[]}args
     * @returns {string}
     */
    HelpersService.prototype.stringFormat = function (text) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return text.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined' ? args[number] : match;
        });
    };
    HelpersService.prototype.currency = function (value, chunkLength, chunkDelimiter) {
        if (chunkLength === void 0) { chunkLength = 3; }
        if (chunkDelimiter === void 0) { chunkDelimiter = '.'; }
        var newValue = this.clearValue(value);
        var regex = "\\d(?=(\\d{" + chunkLength + "})+$)";
        var result = newValue.replace(new RegExp(regex, 'g'), "$&" + chunkDelimiter);
        var zeroValidation = result;
        if (Number(zeroValidation) < 0.01) {
            result = '0';
        }
        return { format: "$" + result.trim(), clearValue: newValue };
    };
    HelpersService.prototype.clearValue = function (value) {
        return value.toString().replace(/\D/g, '').replace(/^0+/, '').substring(0, 12);
    };
    /**
     * Convierte una variable en formato date en un campo valido apra vcl-date-picker
     *
     * *Converts date variable to vcl-datePicker valid variable*
     * @param {Date} date
     */
    HelpersService.prototype.formatingVclDate = function (date) {
        return date.toISOString().slice(0, 10).split('-').reverse().join('/');
    };
    HelpersService.prototype.scrollToTop = function () {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };
    /**
     * Convierte un texto a CamelCase sin espacios
     *
     * *Converts to CamelCase without spaces*
     * @param {string} text
     * @param {boolean} upper
     * @returns {string}
     */
    HelpersService.prototype.parseCamelCaseForIds = function (text, upper) {
        var FIRST_WORD = 0;
        var SECOND_WORD = 1;
        var FIRST_LETTER = 0;
        var SECOND_LETTER = 1;
        var newText = text.split(' ');
        for (var i = SECOND_WORD; i < newText.length; i++) {
            newText[i] = newText[i].charAt(FIRST_LETTER).toUpperCase() + newText[i].slice(SECOND_LETTER);
        }
        if (upper) {
            newText[FIRST_WORD] = newText[FIRST_WORD].charAt(FIRST_LETTER).toUpperCase() + newText[FIRST_WORD].slice(SECOND_LETTER);
        }
        else {
            newText[FIRST_WORD] = newText[FIRST_WORD].charAt(FIRST_LETTER).toLowerCase() + newText[FIRST_WORD].slice(SECOND_LETTER);
        }
        return newText.join('');
    };
    HelpersService.prototype.getRateBySegment = function (rate, segment, rate_type, risk, withoutFormat, isPlazo) {
        var rateBySegment = rate.find(function (seg) { return seg.segment_code === segment; });
        var ratebyType = rateBySegment.rates.find(function (ratesProperties) {
            return ratesProperties.rate_type === rate_type && ratesProperties.risk_category === risk;
        });
        var taxRate = ratebyType.tax_rate;
        if (withoutFormat) {
            return taxRate;
        }
        return this.formatDecimnalNumbers(taxRate.value, taxRate.decimals, isPlazo);
    };
    HelpersService.prototype.formatDecimnalNumbers = function (number, decimals, isPlazo) {
        if (isPlazo && number.toString().length > 4) {
            var tempNumber = number.toString().split('');
            tempNumber.splice(4);
            number = parseInt(tempNumber.join(''), 0);
        }
        decimals = decimals > 2 ? 2 : decimals;
        var numstring = number.toString().split('');
        if (numstring.length > decimals) {
            var numberReverse = numstring.slice().reverse();
            numberReverse.splice(decimals, 0, ',');
            return numberReverse.reverse().join('') + '%';
        }
        numstring.unshift('0,');
        return numstring.join('') + '%';
    };
    /**
     * retorna el codigo dependiendo el segmento
     *
     * *return the product code depending the segment id*
     * @param {string} segment_id
     * @returns {string}
     */
    HelpersService.prototype.getProductCodeBySegmentId = function (segment_id) {
        switch (segment_id) {
            case '343':
            case '345':
            case '346':
                return '122';
            case '347':
            case '348':
                return '128';
            default:
                return '129';
        }
    };
    HelpersService.prototype.validateDiacritialMask = function (value) {
        value = value.replace(/\./g, '');
        value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    };
    HelpersService.prototype.mapBooleanData = function (value) {
        return !(value === ' ' || value === 'NO' || value === null);
    };
    HelpersService.prototype.unRegisterAplication = function (name) {
        unregisterApplication(name).then(function () {
            return true;
        });
    };
    HelpersService.prototype.formatDateCalendar = function (date) {
        return (date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()) + "/" +
            (((date.getMonth() + 1) <= 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + date.getFullYear());
    };
    return HelpersService;
}());
export { HelpersService };
